<template>
  <main class="view index">
    <div v-if="object" class="object">
      <img v-if="showImage" :src="object.image" :alt="object.title" :class="{ loaded }" @load="handleImageLoaded"/>
      <router-link :to="object.url">
        <CTA :to="object.url">mehr erfahren</CTA>
      </router-link>
    </div>
    <!--
    <div v-if="news" class="news" :style="`background-image: url('${news.image}');`">
      <router-link :to="news.url">
        <div>
          <h2>{{ news.title }}</h2>
          <p v-html="news.short" />
        </div>
        <CTA :to="news.url">mehr erfahren</CTA>
      </router-link>
    </div>
    -->
  </main>
</template>

<script>
  import CTA from '@/components/ui/CTA';

  export default {
    name: 'Index',
    components: {
      CTA,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        loaded: false,
        showImage: false,
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      news() {
        let news = this.$b.data?.news || [];
        if (news.length > 0) {
          news = news[0];
          const featured = news?.featured[0] || {};
          const chosenPath = featured?.full || featured?.path;
          return {
            title: news.title,
            short: news.short,
            image: `${this.$b.contentUrl}/${chosenPath}`,
            url: `/news/${news.slug}/`,
          };
        }
        return null;
      },
      object() {
        const objects = this.$b.data?.objects || [];
        if (objects.length > 0) {
          const object = objects[0];
          const featured = object?.featured[0] || {};
          const chosenPath = featured?.full || featured?.path;
          return {
            title: object.title,
            short: object.short,
            image: `${this.$b.contentUrl}/${chosenPath}`,
            url: `/objects/${object.slug}/`,
          };
        }
        return null;
      },
    },
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    filters: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    mounted() {
      this.$nextTick(() => {
        this.showImage = true;
      });
    },
    // beforeUpdate() {},
    updated() {
      this.$nextTick(() => {
        this.showImage = true;
      });
    },
    beforeDestroy() {
      this.showImage = false;
    },
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      handleImageLoaded() {
        setTimeout(() => {
          this.loaded = true;
        }, 250);
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.view.index {
  padding: 0;
  & > div {
    position: relative;
    overflow: hidden;
    display: flex;
    justify-content: center;

    & > img {
      position: relative;
      z-index: 2;
      width: auto;
      height: 100%;
      object-fit: contain;
      object-position: 50% 50%;
      filter: blur(10px);
      opacity: 0;
      transition: filter 0.8s ease-out, opacity 0.6s ease-out;

      &.loaded {
        filter: blur(0px);
        opacity: 1;
      }
    }

    & > a {
      position: absolute;
      left: 50%;
      bottom: 0;
      transform-origin: 50% 100%;
      transform: translate(-50%, 100%) scale(0.85, 0.85);
      background-color: rgba(255,255,255, 0.85);
      box-shadow: 0 0 4px rgba(0,0,0,0.2);
      z-index: 3;
      opacity: 0;
      display: block;
      color: black;
      text-decoration: none;
      transition: opacity 0.3s 1s, transform 0.3s 1s;
      padding: 10px 10px 15px 10px;
      border-radius: 8px 8px 0 0;

      & > a {
        padding: 0;
        margin: 0;
      }
    }

    & > img:hover + a, & > a:hover {
      opacity: 1;
      transform: translate(-50%, 0) scale(0.85, 0.85);
    }
  }
  & > .object {
    width: 100%;
    height: calc(100vh - 120px);

    @include screen-tablet {
      height: calc(100vh - 60px);
    }
  }

  & > .news {
    display: none;
  }
}
</style>
